import styled from "styled-components"
import { ButtonStyles } from './ButtonStyles';

export const ButtonSpan = styled.span`
    ${ButtonStyles};
    
    button {
        color: var(--white);
    }
`;